/**
 * Reads a JWT's payload without verifying it. Only for display (name, id); the server
 * checks the signature on every request, so nothing here is trusted for access decisions.
 */
export function decodeJwtPayload(token: string): Record<string, unknown> | null {
  const payload = token.split('.')[1];
  if (!payload) {
    return null;
  }
  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const bytes = Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));
    const claims: unknown = JSON.parse(new TextDecoder().decode(bytes));
    return typeof claims === 'object' && claims !== null
      ? (claims as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}

export function readStringClaim(
  claims: Record<string, unknown> | null,
  names: readonly string[],
): string | null {
  for (const name of names) {
    const value = claims?.[name];
    if (typeof value === 'string' && value.trim()) {
      return value.trim();
    }
  }
  return null;
}
